import {
	getCurrentDateWithDay,
	parseDayMonthToDate,
} from "@/helpers/format-date";
import { WEATHER_STORE } from "@/store/store";
import { useDispatch } from "@wordpress/data";
import { WeatherDispatch } from "@/store/type";
import { formatWeatherStateIcon } from "@/helpers/format-weather-state-icon";

import ForecastCard from "@/components/forecast/forecast-card/ForecastCard";
import { useEffect, useRef } from "@wordpress/element";
import { IDailyForecastData } from "@/types/daily-forecast-type";

interface IDataExtend extends IDailyForecastData {
	dayWeek: string;
	day: string;
}

type CardWeatherProps = {
	data: IDataExtend;
	selectedDate: Date;
	type: "marine" | "world" | "weather";
};

export const CardWeather = ({
	data,
	selectedDate: selectedDateProps,
	type,
}: CardWeatherProps) => {
	const selectedDate = new Date(selectedDateProps);
	const isActive = data.date.getDate() === selectedDate.getDate();

	const { setPrevisionDateCard, setDateKuwaitForecast } = useDispatch(
		WEATHER_STORE,
	) as WeatherDispatch;

	const { date } = getCurrentDateWithDay(selectedDate);
	const cardRef = useRef<HTMLDivElement | null>(null);

	const weatherIcon = formatWeatherStateIcon({
		timeStep: data.date.toISOString(),
		status: data.ww,
	});

	useEffect(() => {
		if (!isActive || !cardRef.current) return;

		cardRef.current.parentElement?.scrollTo({
			left:
				cardRef.current.offsetLeft -
				cardRef.current.parentElement.clientWidth / 2,
			behavior: "smooth",
		});
	}, [isActive]);

	const handleClick = (dateClick: string) => {
		setPrevisionDateCard({
			type,
			date: parseDayMonthToDate(dateClick),
		});

		setDateKuwaitForecast(parseDayMonthToDate(dateClick));
	};

	return (
		<div ref={isActive ? cardRef : null}>
			<ForecastCard
				updateDateStore={(value: string) => handleClick(value)}
				data={data}
				isActive={isActive}
				date={date}
				type={type}
				image={
					weatherIcon === undefined ? null : (
						<img
							draggable={false}
							className="card-weather-img"
							src={formatWeatherStateIcon({
								timeStep: data.date.toISOString(),
								status: data.ww,
							})}
							alt="weather icon"
						/>
					)
				}
			/>
		</div>
	);
};

export default CardWeather;
